import { IOption } from 'app/components'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** Tipo de telefone (SBIS ECF.02.01); valores do enum `TipoTelefone` do backend. */
export enum TipoTelefoneType {
  Fixo = 'FIXO',
  Celular = 'CELULAR',
  Comercial = 'COMERCIAL',
  Recado = 'RECADO',
}

/** DDD e número derivados da máscara pelo backend (`PessoaView.telefoneEstruturado`). */
export type TelefoneEstruturado = {
  tipo?: TipoTelefoneType | null
  ddd?: string | null
  numero?: string | null
}

const CHAVES: Record<TipoTelefoneType, string> = {
  [TipoTelefoneType.Fixo]: 'tipo_telefone.fixo',
  [TipoTelefoneType.Celular]: 'tipo_telefone.celular',
  [TipoTelefoneType.Comercial]: 'tipo_telefone.comercial',
  [TipoTelefoneType.Recado]: 'tipo_telefone.recado',
}

export const opcoesTipoTelefone = (t: TFunction): IOption<TipoTelefoneType>[] =>
  Object.values(TipoTelefoneType).map((tipo) => ({ label: t(CHAVES[tipo]), value: tipo }))

export const opcaoTipoTelefone = (
  t: TFunction,
  tipo?: TipoTelefoneType | null
): IOption<TipoTelefoneType> | undefined =>
  tipo ? { label: t(CHAVES[tipo]), value: tipo } : undefined
